import React, { useEffect, useRef, useState } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getAnalyticsChoice, setAnalyticsChoice, subscribeAnalyticsChoice } from '../lib/analytics';
import { usePlatform } from '../platform/PlatformContext';
import './cookie-banner.css';

export const CookieBanner = () => {
  const { navigate } = usePlatform();
  const [choice, setChoice] = useState(getAnalyticsChoice);
  const [open, setOpen] = useState(() => !getAnalyticsChoice());
  const [height, setHeight] = useState(0);
  const banner = useRef(null);
  const settings = useRef(null);
  const restoreFocus = useRef(false);
  useEffect(() => subscribeAnalyticsChoice(next => { setChoice(next); setOpen(!next); }), []);
  useEffect(() => {
    if (!open || !banner.current) { setHeight(0); return; }
    const measure = () => setHeight(Math.ceil(banner.current?.getBoundingClientRect().height || 0));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(banner.current);
    return () => observer.disconnect();
  }, [open]);
  useEffect(() => {
    if (!open && restoreFocus.current) { settings.current?.focus({ preventScroll: true }); restoreFocus.current = false; }
  }, [open]);
  const choose = next => { restoreFocus.current = true; setAnalyticsChoice(next); setChoice(next); setOpen(false); };
  return <div className="cookie-ui">
    {!open && <div className="cookie-settings-wrap"><Button ref={settings} variant="ghost" className="cookie-settings" data-testid="cookie-settings-open-button" onClick={() => setOpen(true)} aria-expanded={false}><Cookie size={15}/>Cookie settings</Button></div>}
    {open && <>
      <div data-testid="cookie-banner-spacer" aria-hidden="true" style={{ height }}/>
      <section ref={banner} className="cookie-banner" data-testid="cookie-banner" aria-labelledby="cookie-banner-title">
        <div className="cookie-banner-inner">
          <div className="cookie-copy"><h2 id="cookie-banner-title" data-testid="cookie-banner-title"><Cookie size={18}/>Help us make CubitPlay better</h2><p data-testid="cookie-banner-description">We use a small amount of analytics to understand how people use our games and improve the experience. <a href="/privacy" data-testid="cookie-banner-privacy-link" onClick={event => { if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault(); navigate('/privacy'); } }}>Privacy policy</a></p></div>
          <div className="cookie-actions"><Button className="cookie-choice" data-testid="cookie-banner-accept-button" aria-pressed={choice === 'accepted'} onClick={() => choose('accepted')}>Accept</Button><Button className="cookie-choice" data-testid="cookie-banner-decline-button" aria-pressed={choice === 'declined'} onClick={() => choose('declined')}>Decline</Button></div>
        </div>
      </section>
    </>}
  </div>;
};
